import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { useVigoTranslation } from 'src/@core/hooks/useVigoTranslation';
import { VigoTypography } from 'src/@vigo/vigo-typography';
import Magnify from 'mdi-material-ui/Magnify';
import { Dispatch } from 'react';
import { StatusItem } from '..';

interface FlowPodSectionProps {
  podInfo: StatusItem;
  setDocViewerOpen: Dispatch<boolean>;
}

const FlowPodSection = ({ podInfo, setDocViewerOpen }: FlowPodSectionProps) => {
  // Hooks
  const { t } = useVigoTranslation();

  return (
    <Box sx={{ flexShrink: 0, mb: 2, mt: 10 }}>
      <Box sx={{ border: '1px solid' }}>
        <Grid container direction={'row'}>
          <Grid item xs={6}>
            <Grid container direction="column">
              <Grid item xs={12}>
                <Stack direction="row">
                  <Grid item xs={4}>
                    <Typography sx={{ textAlign: 'right' }}>{`${t('Signed')}:`}</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <VigoTypography
                      value={podInfo.podName ?? ''}
                      disableTranslation
                      sx={{ textAlign: 'left', ml: 1 }}
                    />
                  </Grid>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction="row">
                  <Grid item xs={4}>
                    <Typography sx={{ textAlign: 'right' }}>{`${t('Date/Time')}:`}</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <VigoTypography
                      value={podInfo.date ? format(parseISO(podInfo.date), 'dd/MM/yyyy HH:mm:ss') : ''}
                      disableTranslation
                      sx={{ textAlign: 'left', ml: 1 }}
                    />
                  </Grid>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
            <VigoTypography value="POD" sx={{ textAlign: 'center' }} />
            {podInfo.image && (
              <Box
                sx={{
                  width: '60px',
                  height: '60px',
                  backgroundColor: '#acacac',
                  position: 'relative',
                  '&:hover > div.documentOverlay': { display: 'flex' }
                }}>
                <Box
                  sx={{
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 1 - 0,
                    transform: `translate(${10 * 0}px, -${10 * 0}px)`
                  }}>
                  <img
                    src="/images/pages/epod_tiff.png"
                    alt="epod tiff placeholder"
                    style={{
                      width: '100%',
                      marginBlock: 'auto',
                      display: 'inline-block',
                      objectFit: 'cover',
                      transform: 'scale(2)'
                    }}
                  />
                </Box>

                <Box
                  className="documentOverlay"
                  sx={{
                    display: 'none',
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0, 0.6)',
                    justifyContent: 'flex-end',
                    alignItems: 'flex-end',
                    zIndex: 99
                  }}>
                  <IconButton onClick={() => setDocViewerOpen(true)}>
                    <Magnify htmlColor="#fff" />
                  </IconButton>
                </Box>
              </Box>
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FlowPodSection;
